GameView = require "views/base/game"
Preloader = require("lib/preload")

class ImagePairView extends GameView
  template: require("./template")

  events: ->
    "iostap .image-container": "selectImage"
    "iostap .btn-done": "endGame"

  show: ->
    super
    @setEl @findAll(".image-container"), "images"
    @setEl @findOne(".title"), "title"
    @setEl @findOne(".content-area"), "parent"
    @setState @options.data.reject, "reject"
    @listenTo this, "resize", @onResize

    images = _.chain(@options.metadata.questions)
      .pluck("answers")
      .flatten()
      .pluck("content")
      .union()
      .value()

    Preloader.load images, => @onResize()

    @enterGame()

  onResize: ->
    for image in @getEl("images")
      image.parentNode.style.height = ""

    outerHeight = @getEl("parent").offsetHeight
    outerHeight -= @getEl("title").offsetHeight if @el.offsetWidth < 1024
    groupLength = @options.data.groups.length
    maxHeight   = (outerHeight / groupLength)

    height = _.reduce @getEl("images"), (
      (m, e) -> Math.min(m, e.offsetHeight)
    ), maxHeight

    @getEl("parent").classList.toggle("content-fill", height is maxHeight)
    @getEl("parent").classList.toggle("content-ver", height < maxHeight)

    for image in @getEl("images")
      image.parentNode.style.height = height + "px"

  selectImage: (e) ->
    image = e.currentTarget

    if @options.data.reject and not image.dataset.correct?
      wasIncorrect = true
      image.classList.add "show-incorrect"
      window.setTimeout (-> image.classList.remove "show-incorrect"), 500
    else
      image.classList.toggle "active"

    unless @options.data.multi or wasIncorrect
      for other in @getEl("images")
        if other isnt image and other.dataset.group is image.dataset.group
          other.classList.remove("active")

    @setState(if @isTouched() then "touched" else "prompt")

  isTouched: ->
    if @options.data.multi
      true
    else
      _.chain(@getEl("images"))
        .groupBy((e, i) -> ~~(i / 2))
        .map((group) -> group.filter((e) -> e.classList.contains "active"))
        .reduce(((isTouched, group) -> isTouched and group.length > 0), true)
        .value()

  imageIsCorrect: (image) ->
    image.classList.contains("active") is image.dataset.correct?

  isCorrect: ->
    _.chain(@getEl("images"))
      .map(@imageIsCorrect)
      .reduce(((allCorrect, isCorrect) -> allCorrect and isCorrect), true)
      .value()

  answerDetails: ->
    questions = @options.metadata?.questions or []
    return [] unless questions.length > 0

    questionsById = _.chain(questions)
      .pluck('question')
      .indexBy('id')
      .value()
    answersById = _.chain(questions)
      .pluck('answers')
      .flatten()
      .indexBy('id')
      .value()

    # TODO: fix the question/answer format for this template
    # Each image is it's own question instead of each pair
    return _.chain(@getEl('images'))
      .compact()
      .groupBy((e) -> e.dataset.questionId)
      .map((images, questionId) ->
        # For now we return the selected images as answers
        _.chain(images)
          .filter((i) -> i.classList.contains "active")
          .map((answer) ->
              question: questionsById[questionId]
              answer: answersById[answer.dataset.answerId]
          )
          .value()
      )
      .compact()
      .flatten()
      .value()

  endGame: ->
    super

    @submit()

module.exports = ImagePairView
